// German (DE) — AI-prepared, pending native review before production.
// Keys override the English master copy carried as component defaults.
export default {
  // SEO
  "seo.title": "Eröffnen Sie Ihr Fitnessstudio — Direkt ab Werk | YANRE FITNESS EUROPE",
  "seo.description": "Vom privaten Studio bis zur großen kommerziellen Anlage — professionelle YANRE-Ausstattung, persönliche Projektberatung, internationale Logistik und After-Sales mit Werksgarantie.",

  // Header / nav
  "nav.Why Fitness": "Warum Fitness",
  "nav.Why YANRE": "Warum YANRE",
  "nav.How It Works": "So funktioniert's",
  "nav.Real Projects": "Echte Projekte",
  "nav.visitWebsite": "Website besuchen",
  "header.cta": "Projekt starten",

  // Hero
  "hero.label": "Eröffnen Sie Ihr Fitnessstudio",
  "hero.line1": "Bauen Sie Ihr Fitnessstudio.",
  "hero.line2a": "Kaufen Sie direkt beim",
  "hero.line2b": "Hersteller.",
  "hero.copy": "Von privaten Studios bis zu großen kommerziellen Anlagen — professionelle YANRE-Ausstattung, direkt von einem der führenden chinesischen Hersteller professioneller Fitnessgeräte, mit kommerzieller Betreuung aus Europa, persönlicher Projektberatung, internationaler Logistik und After-Sales-Service ab Werk.",
  "hero.ctaPrimary": "Mein Studio-Projekt starten",
  "hero.ctaSecondary": "Mit einem Experten sprechen",
  "hero.trust.0": "Direkt ab Werk",
  "hero.trust.1": "Projektberatung",
  "hero.trust.2": "Internationale Logistik",
  "hero.trust.3": "Werksgarantie",

  // Marquee
  "marquee.Precision": "Präzision",
  "marquee.Performance": "Leistung",
  "marquee.Confidence": "Vertrauen",
  "marquee.Engineering": "Ingenieurskunst",
  "marquee.Since 1997": "Seit 1997",

  // CTA strips
  "strip.1": "Bereit, über Ihr Projekt zu sprechen?",
  "strip.2": "Wissen Sie, was Sie brauchen? Sprechen wir.",
  "strip.3": "Genug gesehen? Starten Sie Ihr Projekt.",
  "strip.cta": "Projekt starten",

  // Section labels (SectionLabel children as keys)
  "label.Why Invest in Fitness": "Warum in Fitness investieren",
  "label.Fitness Market Proof": "Fitnessmarkt in Zahlen",
  "label.New to Fitness? That's OK.": "Neu im Fitnessbereich? Kein Problem.",
  "label.Factory Direct": "Direkt ab Werk",
  "label.Factory Direct Purchase Process": "Kaufprozess direkt ab Werk",
  "label.Featured Equipment": "Ausgewählte Geräte",
  "label.Engineered Differently": "Anders konstruiert",
  "label.Built Around Your Business": "Rund um Ihr Geschäft gebaut",
  "label.Why YANRE FITNESS": "Warum YANRE FITNESS",
  "label.The Founder": "Der Gründer",
  "label.YANRE Gyms Around the World": "YANRE-Studios weltweit",
  "label.International Logistics": "Internationale Logistik",
  "label.After-Sales & Warranty": "After-Sales & Garantie",
  "label.Start Your Project": "Starten Sie Ihr Projekt",
  "label.Milestones": "Meilensteine",
  "label.Engineering Philosophy": "Konstruktionsphilosophie",

  // WhatsApp
  "wa.title": "WhatsApp",
  "wa.subtitle": "Mit einem Experten sprechen",

  // Footer
  "footer.contact": "Kontakt",
  "footer.legal": "Rechtliches",
  "footer.privacy": "Datenschutzerklärung",
  "footer.cookies": "Cookie-Richtlinie",
  "footer.terms": "AGB",
  "footer.visit": "Website von YANRE FITNESS EUROPE besuchen",

  // Form — steps
  "step.1": "Projekt",
  "step.2": "Fläche",
  "step.3": "Investition",
  "step.4": "Kontakt",
  "step.5": "Projektbedarf",
  "step.6": "Logistik",
  "step.7": "Kauf",
  "step.8": "Ihre Rolle",
  "step.9": "Standort",
  "step.10": "Kontakt",
  "step.11": "Abschließende Angaben",
  "form.progress": "Schritt",
  "form.title1": "Planen Sie das Projekt",
  "form.title2": "Ihres Fitnessstudios.",
  "form.subtitle": "Erzählen Sie uns, was Sie planen. Wir helfen Ihnen, die richtige Ausstattungslösung zu finden.",
  "form.intro.sub1": "4 SCHNELLE SCHRITTE.",
  "form.intro.sub2": "EINE KOMPLETTE LÖSUNG FÜR IHR GYM.",
  "form.intro.support": "Erzählen Sie uns in nur 4 einfachen Schritten von Ihrem Projekt. Unser Team versteht Ihre Anforderungen und hilft Ihnen, die passende Lösung zu bauen — mit direkter Werkslieferung von YANRE FITNESS China, professioneller Beratung und After-Sales-Support.",
  "form.intro.minute": "FERTIG IN 1 MINUTE",
  "form.back": "Zurück",
  "form.continue": "Weiter",
  "form.submit": "Mein Gym-Projekt anfordern",
  "form.sending": "Wird gesendet…",

  // Form — questions
  "q.projectType": "Was beschreibt Ihr Projekt am besten?",
  "q.franchiseStatus": "Sind Sie bereits mit einem Fitness-Franchise verbunden?",
  "q.locationStatus": "Haben Sie bereits einen Standort für das Projekt?",
  "q.facilityArea": "Wie groß ist die verfügbare Fläche ungefähr?",
  "q.projectStage": "In welcher Phase befindet sich Ihr Projekt?",
  "q.openingTimeline": "Wann planen Sie die Eröffnung Ihres Projekts?",
  "q.investmentBand": "Wie hoch ist Ihr geschätzter Investitionsrahmen? (USD)",
  "q.investmentHint": "Eine Schätzung genügt. Sie hilft uns, die richtige Lösung für Ihr Projekt zu empfehlen.",
  "q.projectNeed": "Was benötigen Sie für Ihr Projekt?",
  "q.projectNeedHint": "Wählen Sie alle zutreffenden Optionen.",
  "q.equipmentListStatus": "Haben Sie bereits eine Geräteliste?",
  "q.logisticsPreference": "Wie möchten Sie die internationale Logistik abwickeln?",
  "q.purchaseMethod": "Wie planen Sie derzeit den Kauf Ihrer Geräte?",
  "q.competitorComparison": "Vergleichen Sie derzeit andere Gerätemarken?",
  "q.competitorBrands": "Welche Marken ziehen Sie in Betracht?",
  "q.decisionRole": "Welche Rolle haben Sie in diesem Projekt?",
  "q.country": "Land des Projekts",
  "q.city": "Stadt",
  "q.firstName": "Vorname",
  "q.lastName": "Nachname",
  "q.company": "Firma / Name des Gyms (optional)",
  "q.email": "E-Mail-Adresse",
  "q.phone": "WhatsApp / Telefon",
  "q.preferredContact": "Bevorzugte Kontaktmethode",
  "q.notes": "Gibt es noch etwas, das wir über Ihr Projekt wissen sollten?",
  "q.optional": "Optional",
  "q.selectCountry": "Land auswählen",

  // Form — option labels (canonical values unchanged)
  "opt.commercial-gym": "Komplettes Gym-Projekt",
  "opt.boutique-gym": "Boutique-Fitnessstudio",
  "opt.pt-studio": "Personal Training Studio",
  "opt.home-gym": "Privates Home-Gym",
  "opt.residential-gym": "Wohnanlagen- / Residential-Gym",
  "opt.hotel-resort": "Hotel- / Resort-Fitness",
  "opt.corporate-gym": "Corporate Gym",
  "opt.sports-facility": "Sport- / Leistungsanlage",
  "opt.franchise": "Gym-Franchise",
  "opt.other": "Sonstiges",
  "opt.own-franchise": "Ja — ich besitze / betreibe bereits ein Franchise",
  "opt.acquiring-franchise": "Ja — ich erwerbe gerade ein Franchise",
  "opt.evaluating-franchise": "Ich prüfe Franchise-Möglichkeiten",
  "opt.independent": "Nein — ich erkunde das Fitnessgeschäft unabhängig",
  "opt.confirmed": "Ja — Standort bestätigt",
  "opt.negotiating": "Standort in Verhandlung",
  "opt.looking": "Noch auf Standortsuche",
  "opt.up-to-100": "Bis 100 m²",
  "opt.100-250": "100–250 m²",
  "opt.250-500": "250–500 m²",
  "opt.500-1000": "500–1.000 m²",
  "opt.1000-2000": "1.000–2.000 m²",
  "opt.2000-plus": "2.000+ m²",
  "opt.exploring": "Investmentmöglichkeiten erkunden",
  "opt.initial-planning": "Frühe Planung",
  "opt.business-plan": "Businessplan / Investitionsplanung",
  "opt.location-selected": "Standort ausgewählt",
  "opt.architecture": "Architektur / Design",
  "opt.construction": "Bau / Renovierung",
  "opt.ready-to-purchase": "Bereit zum Gerätekauf",
  "opt.expansion": "Neueröffnung / Erweiterung",
  "opt.within-2": "Innerhalb von 2 Monaten",
  "opt.2-4": "2–4 Monate",
  "opt.4-6": "4–6 Monate",
  "opt.6-12": "6–12 Monate",
  "opt.12-plus": "12+ Monate",
  "opt.up-to-50k": "Weniger als 50.000 USD",
  "opt.50-150k": "50.000–150.000 USD",
  "opt.150-300k": "150.000–300.000 USD",
  "opt.300-500k": "300.000–500.000 USD",
  "opt.500k-1m": "500.000–1M USD",
  "opt.1m-plus": "Über 1M USD",
  "opt.complete-equipment": "Komplette Studioausstattung",
  "opt.strength": "Kraftgeräte",
  "opt.cardio": "Cardiogeräte",
  "opt.full-project-help": "Ich benötige Hilfe beim gesamten Projekt",
  "opt.have-list": "Ja — ich habe bereits eine Geräteliste",
  "opt.need-review": "Teilweise — ich habe eine erste Auswahl",
  "opt.need-list": "Nein — ich brauche die Hilfe von YANRE",
  "opt.yanre-coordination": "Ich wünsche YANRE-Logistikkoordination",
  "opt.own-partner": "Ich habe bereits einen Logistikpartner",
  "opt.compare-both": "Ich möchte beide Optionen vergleichen",
  "opt.need-guidance": "Ich benötige Beratung vor der Entscheidung",
  "opt.direct": "Direkt beim Hersteller",
  "opt.dealer": "Lokaler Fitnessgeräte-Händler",
  "opt.distributor": "Distributor / Importeur",
  "opt.comparing": "Verschiedene Kaufoptionen vergleichen",
  "opt.researching": "Noch auf der Suche nach Lieferanten",
  "opt.yes": "Ja",
  "opt.no": "Nein",
  "opt.owner": "Inhaber / Gründer",
  "opt.investor": "Investor",
  "opt.partner": "Partner",
  "opt.director": "Direktor / Geschäftsführer",
  "opt.manager": "Studioleiter",
  "opt.procurement": "Einkauf / Beschaffung",
  "opt.architect": "Architekt / Designer",
  "opt.consultant": "Berater",
  "opt.trainer": "Personal Trainer",
  "opt.whatsapp": "WhatsApp",
  "opt.phone": "Telefonanruf",
  "opt.email": "E-Mail",

  // Form — validation
  "err.projectType": "Bitte wählen Sie aus, was Sie bauen möchten.",
  "err.franchiseStatus": "Bitte geben Sie Ihren Franchise-Status an.",
  "err.locationStatus": "Bitte wählen Sie Ihren Standortstatus.",
  "err.facilityArea": "Bitte wählen Sie die ungefähre Fitnessfläche.",
  "err.projectStage": "Bitte wählen Sie die Phase Ihres Projekts.",
  "err.openingTimeline": "Bitte wählen Sie den geplanten Eröffnungszeitraum.",
  "err.investmentBand": "Bitte wählen Sie Ihr geschätztes Investitionsbudget für Geräte.",
  "err.projectNeed": "Bitte wählen Sie mindestens einen Projektbedarf.",
  "err.equipmentListStatus": "Bitte wählen Sie den Status Ihrer Geräteliste.",
  "err.logisticsPreference": "Bitte wählen Sie eine Logistikpräferenz.",
  "err.purchaseMethod": "Bitte wählen Sie Ihren Kaufplan.",
  "err.competitorComparison": "Bitte teilen Sie uns mit, ob Sie Marken vergleichen.",
  "err.decisionRole": "Bitte wählen Sie Ihre Rolle in diesem Projekt.",
  "err.country": "Bitte wählen Sie das Projektland.",
  "err.city": "Bitte geben Sie die Projektstadt an.",
  "err.firstName": "Bitte geben Sie Ihren Vornamen ein.",
  "err.lastName": "Bitte geben Sie Ihren Nachnamen ein.",
  "err.email": "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
  "err.phone": "Bitte geben Sie Ihre WhatsApp- / Telefonnummer ein.",
  "err.preferredContact": "Bitte wählen Sie Ihre bevorzugte Kontaktmethode.",
  "err.privacyConsent": "Bitte akzeptieren Sie die Datenschutzeinwilligung, um Ihr Projekt zu senden.",
  "err.submit": "Beim Senden Ihres Projekts ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",

  // Form — consent & success
  "consent.privacy": "Ich stimme zu, dass YANRE FITNESS EUROPE meine Daten verarbeitet, um mich zu diesem Projekt zu kontaktieren.",
  "consent.marketing": "Ich möchte gelegentlich Neuigkeiten und Angebote von YANRE FITNESS EUROPE erhalten. (Optional)",
  "success.title1": "Projekt erhalten",
  "success.body": "Vielen Dank. Ein Experte von YANRE FITNESS EUROPE wird Ihr Projekt prüfen und Sie über Ihren bevorzugten Kanal kontaktieren.",
  "success.reference": "Referenz",

  // ===== Section copy =====
  "wi.h1a": "Auf der Suche nach Ihrem nächsten Geschäft?",
  "wi.h1b": "Denken Sie an Fitness.",
  "wi.fitnessCol": "Fitnessgeschäft",
  "wi.retailCol": "Traditioneller Einzelhandel",
  "wi.f1": "Wiederkehrende Mitgliedsbeiträge",
  "wi.f2": "Kein Wareninventar",
  "wi.f3": "Keine tägliche Wiederbeschaffung",
  "wi.f4": "Prepaid- / wiederkehrender Zugang",
  "wi.f5": "Potenzial für schlanke Abläufe",
  "wi.f6": "Digitales Management",
  "wi.f7": "Geräte = langfristiges produktives Anlagegut",
  "wi.r1": "Täglich verkaufen",
  "wi.r2": "Lagerbestand verwalten",
  "wi.r3": "Ständige Nachbestellungen",
  "wi.r4": "Umsatz von Transaktion zu Transaktion",
  "wi.r5": "Betrieb mit Inventar",
  "wi.r6": "Mehr operative Komplexität",
  "wi.r7": "Der Lagerbestand muss ständig umschlagen",
  "wi.note": "Ein struktureller Vergleich von Geschäftsmodellen — keine Bewertung anderer Branchen.",
  "mp.s1": "Umsatz des europäischen Fitnessmarkts 2025",
  "mp.s2": "Fitnessstudiomitglieder in Europa 2025",
  "mp.s3": "Durchschnittliches globales Umsatzwachstum der Fitnessbranche 2024",
  "mp.s4": "Median-EBITDA-Marge unter den Betreibern der referenzierten HFA-Benchmarking-Studie",
  "mp.opsLabel": "Große Betreiber expandieren",
  "mp.o1": "Neue Mitglieder der 20 größten Betreiber Europas 2025",
  "mp.o2": "Kombinierter Umsatz der 20 größten Betreiber Europas 2025",
  "mp.o3": "Große M&A-Transaktionen im europäischen Fitnessmarkt 2025",
  "mp.src": "Quellen: Health & Fitness Association · EuropeActive / Deloitte. Branchen-Benchmarking-Daten — keine Garantie für individuelle Ergebnisse.",
  "nf.h1a": "Sie müssen nicht aus der",
  "nf.h1b": "Fitnessbranche kommen.",
  "nf.b1": "Sie bringen die Investition und die Geschäftsvision mit.",
  "nf.b2": "Wir helfen, den Geräteteil des Projekts zu strukturieren.",
  "fd.h1a": "Schalten Sie die Zwischenhändler aus.",
  "fd.h1b": "Nicht den Support.",
  "fd.tradLabel": "Traditionelles Modell",
  "fd.directLabel": "YANRE Direkt ab Werk",
  "fd.t1": "Hersteller",
  "fd.t2": "Distributor / Importeur",
  "fd.t3": "Händler / Einzelhändler",
  "fd.t4": "Kunde",
  "fd.customer": "Kunde",
  "fd.trust": "Ihr Gerätevertrag und Ihre Zahlungen erfolgen direkt mit YANRE FITNESS — dem Hersteller in China — mit kommerzieller Betreuung aus Europa.",
  "fd.supportLabel": "Direkt ab Werk bedeutet nicht allein zu sein",
  "fd.s1": "Persönliche Beratung",
  "fd.s2": "Technische Anleitung",
  "fd.s3": "Geräteauswahl",
  "fd.s4": "Projektunterstützung",
  "fd.s5": "Optionale Logistikkoordination",
  "fd.s6": "After-Sales-Support",
  "fd.s7": "Werksgarantie",
  "pp.h1a": "Ein klarer Prozess.",
  "pp.h1b": "Vom Projekt bis zum After-Sales.",
  "pp.1.t": "Projektbriefing",
  "pp.1.b": "Der Kunde erläutert Fläche, Konzept, Investition und Zeitplan.",
  "pp.2.t": "YANRE-Beratung",
  "pp.2.b": "Geräteauswahl, technische Anleitung und Projektkonfiguration.",
  "pp.3.t": "Werksvertrag",
  "pp.3.b": "Finale Offerte und offizielle Gerätebestellung direkt bei YANRE FITNESS.",
  "pp.4.t": "30 % Zahlung ans Werk",
  "pp.4.b": "Standard-Anzahlung direkt an YANRE FITNESS; die Bestellung geht in Produktion.",
  "pp.5.t": "Produktion",
  "pp.5.b": "Fertigung und Vorbereitung der Geräte.",
  "pp.6.t": "70 % Zahlung ans Werk",
  "pp.6.b": "Standard-Restzahlung direkt an YANRE FITNESS nach der Produktion und vor dem Versand, gemäß offiziellem Vertrag.",
  "pp.7.t": "Internationaler Versand",
  "pp.7.b": "Der Kunde kann seinen eigenen Logistikpartner nutzen oder eine Logistikkoordination anfordern.",
  "pp.8.t": "After-Sales",
  "pp.8.b": "Laufender Support und Werksgarantie nach der Lieferung.",
  "pp.payTitle": "100 % der Gerätezahlungen erfolgen direkt an YANRE FITNESS.",
  "pp.paySub": "Keine Gerätezahlung erfolgt an Agenten, Berater oder Zwischenhändler.",
  "pp.disclaimer": "Dargestellt ist die Standard-Zahlungsstruktur. Die finalen Handels- und Zahlungsbedingungen werden im offiziellen YANRE FITNESS-Kaufvertrag festgelegt.",
  "fe.h1a": "Gemacht für Leistung.",
  "fe.h1b": "Gebaut, um gesehen zu werden.",
  "fe.tagline": "Ihre Geräte sind Teil Ihrer Marke.",
  "fe.i0.cat": "Kraftgeräte mit Gewichtsblock",
  "fe.i0.series": "73 Tough Series",
  "fe.i0.stmt": "Kraftgeräte mit Gewichtsblock, konzipiert für den täglichen professionellen Einsatz.",
  "fe.i1.cat": "Plate Loaded",
  "fe.i1.series": "Plate-Loaded Power",
  "fe.i1.stmt": "Plate-Loaded-Maschinen, gebaut um die natürliche Bewegung.",
  "fe.i2.cat": "Duale Funktion",
  "fe.i2.series": "C4D Duale Funktion",
  "fe.i2.stmt": "Zwei Stationen auf einer Fläche — maximale Trainingsdichte.",
  "fe.i3.cat": "Kommerzielles Cardio",
  "fe.i3.series": "Kommerzielles Cardio",
  "fe.i3.stmt": "Cardiogeräte, gebaut für kommerzielle Umgebungen im Dauerbetrieb.",
  "dd.h1a": "Der Unterschied",
  "dd.h1b": "liegt im Detail.",
  "dd.0.t": "Originale Konstruktion",
  "dd.0.s": "Von YANRE entwickeltes Design.",
  "dd.1.t": "Patentiertes Design",
  "dd.1.s": "Originales, patentiertes Gerätedesign.",
  "dd.2.t": "Rahmenkonstruktion",
  "dd.2.s": "Rahmen- und Rohrkonstruktion in der Nahaufnahme.",
  "dd.3.t": "Geschwungenes Rahmendesign",
  "dd.3.s": "Rahmengeometrie, geformt um die Bewegung.",
  "dd.4.t": "Polsterung & Kissen",
  "dd.4.s": "Professionelle Polsterung, Nähte und Verarbeitung.",
  "dd.5.t": "Seil- / Rollen- / Führungssystem",
  "dd.5.s": "Präzisionskomponenten für die Bewegung.",
  "dd.6.t": "Biomechanik",
  "dd.6.s": "Drehpunkte und Bewegungsbahnen, entworfen um den Körper.",
  "dd.7.t": "Kommerzielle Bauweise",
  "dd.7.s": "Gebaut für Langlebigkeit und täglichen professionellen Einsatz.",
  "bt.0": "Kommerzielles Fitnessstudio",
  "bt.1": "Premium-Fitnessclub",
  "bt.2": "Boutique-Fitnessstudio",
  "bt.3": "Personal-Training-Studio",
  "bt.4": "Kraft- / Leistungsstudio",
  "bt.5": "Functional-Training-Anlage",
  "bt.6": "Professionelles privates Home-Gym",
  "bt.7": "Wohnanlagen- / Residential-Fitnessstudio",
  "bt.8": "Hotel / Resort",
  "bt.9": "Firmenfitness",
  "bt.10": "Franchise-Standort",
  "wy.h1a": "Aus Erfahrung entworfen.",
  "wy.h1b": "Für Leistung gebaut.",
  "wy.p1.t": "Fertigung",
  "wy.p1.b": "Eigenproduktion kommerzieller Kraftsysteme — von YANRE konstruiert und in den eigenen Werken in China gefertigt, nicht aus Fremddesigns montiert.",
  "wy.p2.t": "Konstruktion & Biomechanik",
  "wy.p2.b": "Originales Design seit 1997, mit über 200 Patenten für Gerätetechnik und Bewegungsbiomechanik.",
  "wy.p3.t": "Kommerzielle Langlebigkeit",
  "wy.p3.b": "Geräte für den täglichen professionellen Einsatz, zertifiziert nach CE-, TÜV- und ISO-Normen.",
  "wy.p4.t": "Produktentwicklung",
  "wy.p4.b": "Eine herstellergeführte Produktpalette — von der 73 Tough Series über Plate-Loaded-Linien, Dual-Function-Maschinen bis zu kommerziellem Cardio.",
  "wy.p5.t": "Internationale Erfahrung",
  "wy.p5.b": "Vertrauen professioneller Studios in über 110 Ländern, mit über 34.950 weltweit realisierten Studioprojekten.",
  "wy.proof0": "Seit 1997",
  "wy.proof1": "200+ Patente",
  "wy.proof2": "110+ Länder",
  "wy.proof3": "CE · TÜV · ISO",
  "wy.proof4": "34.950+ Projekte",
  "fo.navFactory": "Das Werk",
  "fo.navFounder": "Der Mann hinter der Maschine",
  "fo.h1a": "Der Mann",
  "fo.h1b": "hinter",
  "fo.h1c": "der Maschine.",
  "fo.role": "Gründer & Chefdesigner",
  "fo.body": "Athlet, Ingenieur und Gründer von YANRE. Seit 1997 baut er Maschinen für Menschen, die Konstruktion über Marketing stellen.",
  "fo.quote": "„Um die Maschine zu verstehen, muss man den Mann dahinter verstehen.“",
  "fo.st1.t": "Der Anfang",
  "fo.st1.b": "1991 war George Yang noch kein Gründer — er war Techniker und reparierte Fitnessgeräte für Chinas nationale Kaderathleten. Das Reparieren offenbarte die Wahrheit; er trainierte selbst an den Maschinen, um genau zu spüren, wo sie versagten.",
  "fo.st2.t": "Das Problem",
  "fo.st2.b": "Selbst die „besten“ Marken der Welt hatten Schwächen — schwache Schweißnähte, schlechte Winkel und Designs, die den menschlichen Körper ignorierten. Die Grenzen, die er sah, prägten eine völlig neue Art, über Geräte nachzudenken.",
  "fo.st3.t": "Die Gründung",
  "fo.st3.b": "1997 hörte er auf, die Fehler anderer zu korrigieren, und setzte seinen eigenen Standard — er gründete Yangrui Fitness in Peking, benannt nach seinem Sohn. Der Name entwickelte sich von Yangrui zu Yanre und dann YR; der Standard änderte sich nie.",
  "fo.st4.t": "Der Ingenieur",
  "fo.st4.b": "Er lehnt Kompromisse bei Materialien ab: qualifizierter Q235-Stahl mit mindestens 3 mm, 30CrMnSiA-Stangen, reibungsarme POM-Nocken und -Rollen sowie aus Japan importierte Seile mit 1400-kg-Klassifizierung. „Ich trainiere selbst an diesen Maschinen.“",
  "fo.st5.t": "Der Designer",
  "fo.st5.b": "Seine Philosophie ist klar und minimalistisch — Design ist nicht das Aussehen, es ist die Funktion. YANRE konstruiert, statt zu kopieren; die 73 Series war weltweit die erste mit unabhängigen, konvergenten und divergenten Bewegungsbahnen.",
  "fo.st6.t": "Die Vision",
  "fo.st6.b": "Eine Manufaktur von Handwerkern, kein Lager voller Kisten — Mindestbestellmenge von einem Gerät, echte Individualisierung und Support, der für das zehnte Jahr eines Studios gedacht ist, nicht nur für den ersten Tag. Ein Partner, kein Boss.",
  "fo.m1.t": "Frühe technische Erfahrung",
  "fo.m1.b": "Techniker für Chinas nationale Kaderathleten.",
  "fo.m2.t": "Gründung von YANRE",
  "fo.m2.b": "Yangrui Fitness in Peking gegründet.",
  "fo.m3.t": "Die 73 Series",
  "fo.m3.b": "Weltweit die erste mit unabhängigen, konvergenten und divergenten Bewegungsbahnen.",
  "fo.pqA": "„Wir machen Produkte mit",
  "fo.pqHeart": "Herz",
  "fo.pqB": ", und wir machen Produkte mit",
  "fo.pqStandard": "Standard",
  "fo.pqEnd": ".“",
  "fo.c1.t": "Materialien",
  "fo.c1.b": "Q235-Stahl, mindestens 3 mm. POM-Nocken. 1400-kg-Seile.",
  "fo.c2.t": "Biomechanik",
  "fo.c2.b": "Bewegungsbahnen, entworfen um den menschlichen Körper.",
  "fo.c3.t": "Langlebigkeit",
  "fo.c3.b": "Gebaut für über 10 Jahre professionellen Einsatz.",
  "fo.c4.t": "Standard",
  "fo.c4.b": "ISO 20957 als Ausgangspunkt — niemals als Obergrenze.",
  "cc.h1a": "Echte Studios.",
  "cc.h1b": "Echte Geschäfte.",
  "cc.h1c": "Echte YANRE.",
  "cc.case0.title": "Premium-Optik. Professionelle Installation.",
  "cc.case1.title": "Schlichtes Layout. Solide Installation.",
  "cc.case2.title": "Funktionaler Stil. Professionelle Ausstattung.",
  "cc.videoPending": "Vollständiges Projektvideo auf Anfrage erhältlich",
  "lg.h1a": "Ihre Geräte. Ihr Ziel.",
  "lg.h1b": "Ihre Wahl.",
  "lg.option": "Option",
  "lg.o1.t": "Nutzen Sie Ihren Logistikpartner",
  "lg.o1.b": "Arbeiten Sie mit dem Logistikdienstleister, dem Sie bereits vertrauen. Wir bereiten Ihre Bestellung für den Export vor und koordinieren mit Ihrem Partner.",
  "lg.o2.t": "Überlassen Sie uns die Koordination",
  "lg.o2.b": "Fordern Sie die YANRE-Logistikkoordination gemäß dem vertraglich vereinbarten Umfang an — vom Werk bis zum Zielhafen.",
  "lg.f1": "Werk",
  "lg.f2": "Export",
  "lg.f3": "Seefracht",
  "lg.f4": "Zielhafen",
  "lg.disclaimer": "Zollabfertigung, Steuern, Gebühren und Letzte-Meile-Services sind nur enthalten, wenn ausdrücklich vertraglich vereinbart.",
  "lg.cta": "Logistik in mein Projekt aufnehmen",
  "as.h1a": "Die Beziehung endet nicht,",
  "as.h1b": "wenn der Container abfährt.",
  "as.1.t": "Werksgarantie",
  "as.1.b": "Hersteller-Garantiesupport für Ihre Geräte.",
  "as.2.t": "Technischer Support",
  "as.2.b": "Direkte technische Unterstützung, verbunden mit den Menschen hinter den Geräten.",
  "as.3.t": "Ersatzteilsupport",
  "as.3.b": "Ersatzteilunterstützung auf Herstellerebene für Ihre Maschinen.",
  "as.4.t": "After-Sales-Betreuung",
  "as.4.b": "Laufende After-Sales-Betreuung nach der Lieferung.",

  // Cookie consent & policy
  "ck.title": "Ihre Datenschutzoptionen",
  "ck.desc": "Wir verwenden optionale Analyse- und Werbe-Cookies nur mit Ihrer Einwilligung. Sie können Ihre Auswahl jederzeit ändern oder widerrufen.",
  "ck.acceptAll": "Alle Akzeptieren",
  "ck.reject": "Nicht Notwendige Ablehnen",
  "ck.manage": "Einstellungen Verwalten",
  "ck.save": "Auswahl Speichern",
  "ck.necessary": "Notwendig",
  "ck.necessaryDesc": "Erforderlich für den Betrieb der Website. Immer aktiv.",
  "ck.analytics": "Analyse",
  "ck.analyticsDesc": "Anonyme Nutzungsstatistiken, die uns helfen, diese Website zu verbessern.",
  "ck.advertising": "Werbung",
  "ck.advertisingDesc": "Dienen der Messung von Kampagnen und der Ausspielung relevanter Werbung.",
  "ck.alwaysOn": "Immer aktiv",
  "ck.prefsTitle": "Cookie-Einstellungen",
  "ck.policy": "Cookie-Richtlinie",
  "ck.privacy": "Datenschutzerklärung",
  "footer.cookiePrefs": "Cookie-Einstellungen",
  "cp.title": "Cookie-Richtlinie",
  "cp.updated": "Zuletzt aktualisiert: Juli 2026",
  "cp.intro": "Diese Seite erklärt, wie YANRE FITNESS EUROPE Cookies und ähnliche Technologien auf dieser Website verwendet und wie Sie diese steuern können.",
  "cp.s1t": "Was wir speichern",
  "cp.s1b": "Wenn Sie eine Einwilligungsauswahl treffen, speichern wir nur diese Auswahl (notwendig, Analyse, Werbung) im lokalen Speicher Ihres Browsers. Sie enthält keine personenbezogenen Daten und dient ausschließlich dazu, Ihre Präferenz zwischen Besuchen zu speichern.",
  "cp.s2t": "Cookie-Kategorien",
  "cp.s3t": "Google Tag Manager & Consent Mode",
  "cp.s3b": "Diese Website lädt einen Google-Tag-Manager-Container mit Google Consent Mode v2. Jegliche optionale Speicherung (Analyse und Werbung) ist standardmäßig auf „denied“ gesetzt und wird erst nach Ihrer ausdrücklichen Einwilligung aktiviert. Es sind keine Analyse- oder Werbe-Tags direkt auf dieser Website installiert.",
  "cp.s4t": "Ihre Einwilligung verwalten",
  "cp.s4b": "Sie können Ihre Einwilligung jederzeit über den Link „Cookie-Einstellungen“ im Footer der Website ändern oder widerrufen. Der Widerruf gilt sofort.",
  "cp.s5t": "Kontakt",
  "cp.privacyT": "Datenschutz",
  "cp.privacyB": "Unsere vollständige Datenschutzerklärung wird derzeit finalisiert. Bei Fragen oder Anliegen zu Ihren personenbezogenen Daten kontaktieren Sie uns bitte über die oben genannte E-Mail-Adresse.",
  "cp.back": "Zurück zur Startseite",

  "q.fullName": "Vollständiger Name",
  "opt.upgrade-expand": "Ausbau / Erweiterung eines bestehenden Gyms",
  // ===== PERSONAL TRAINER STUDIO (pts.*) — de =====
  "pts.seo.title": "Personal Training Studio — Professionelle Fitnessgeräte | YANRE FITNESS",
  "pts.seo.description": "Eröffnen Sie Ihr eigenes Personal Training Studio mit professionellen YANRE-Fitnessgeräten, direkt vom Hersteller. Durchdachte Startpakete, intelligente Raumplanung und Unterstützung direkt ab Werk.",
  "pts.nav.talk": "Mit einem Spezialisten sprechen",
  "pts.header.cta": "Mein Studio starten",
  "pts.hero.label": "Personal Training Studio",
  "pts.hero.line1": "Ihr Studio.",
  "pts.hero.line2": "Ihre Kunden.",
  "pts.hero.line3": "Ihr Business.",
  "pts.hero.subhead": "Bauen Sie Ihr professionelles Personal Training Studio mit YANRE.",
  "pts.hero.copy": "Vom ersten privaten Studio bis zum Premium-Trainingsraum — professionelle YANRE-Fitnessgeräte, direkt aus den eigenen Werken in China gefertigt, mit intelligenter Raumplanung und kommerzieller Betreuung aus Europa.",
  "pts.hero.ctaPrimary": "Mein Studio starten",
  "pts.hero.ctaSecondary": "Mit einem Spezialisten sprechen",
  "pts.hero.trust.0": "Professionelle Qualität",
  "pts.hero.trust.1": "Direkt vom Hersteller",
  "pts.hero.trust.2": "Werksgarantie",
  "pts.hero.trust.3": "Logistik-Support",
  "pts.journey.label": "Der Übergang",
  "pts.journey.h2a": "Vom Personal Trainer",
  "pts.journey.h2b": "zum Studio-Inhaber.",
  "pts.journey.copy": "Kunden im Fitnessstudio eines anderen zu trainieren, baut dessen Business auf. Ihr eigenes Studio baut Ihres auf — Ihr Raum, Ihre Kundenbeziehungen, Ihre Marke, Ihr Vermögenswert. Unabhängigkeit beginnt mit einem Raum und der richtigen Ausstattung.",
  "pts.journey.0": "Personal Trainer",
  "pts.journey.1": "Ihr Eigenes Studio",
  "pts.journey.2": "Ihre Eigenen Kunden",
  "pts.journey.3": "Ihre Eigene Marke",
  "pts.journey.4": "Ihr Eigenes Business",
  "pts.journey.direct": "Direkt vom Hersteller.",
  "pts.journey.directCopy": "Statten Sie Ihr Studio mit professionellen Geräten aus, die Sie direkt bei YANRE kaufen — dem Hersteller, der jede Maschine entwickelt und produziert.",
  "pts.journey.note": "Keine Versprechen, keine Abkürzungen — nur die Struktur, um aus Ihrem Handwerk ein Business zu machen, das Ihnen gehört.",
  "pts.pkg.label": "Zwei Wege zum Start",
  "pts.pkg.h2a": "Starten Sie klug.",
  "pts.pkg.h2b": "Wachsen Sie zu Ihren Bedingungen.",
  "pts.pkg.intro": "Ein professionelles Studio beginnt mit einem sorgfältig ausgewählten Gerätepaket — und wächst mit der Zeit. Jede Zusammenstellung wird auf Ihren Raum, Ihre Trainingsmethodik und Ihr Investitionsniveau zugeschnitten.",
  "pts.pkg.tag": "Paket",
  "pts.pkg.starter.name": "Starter",
  "pts.pkg.starter.pos": "Alles, was Sie brauchen, um ein professionelles privates Trainingsstudio zu eröffnen.",
  "pts.pkg.starter.i0": "Erstes Studio",
  "pts.pkg.starter.i1": "Personal Trainer",
  "pts.pkg.starter.i2": "Kleine Flächen",
  "pts.pkg.starter.i3": "1-zu-3-Training",
  "pts.pkg.starter.i4": "Semi-privates Training",
  "pts.pkg.starter.concept": "Eine sorgfältig ausgewählte Kombination aus grundlegenden Kraftgeräten, Functional-Training- und Freihantel-Ausstattung.",
  "pts.pkg.starter.cta": "Mein Starter-Studio starten",
  "pts.pkg.studiopro.name": "Studio Pro",
  "pts.pkg.studiopro.pos": "Eine komplette professionelle Ausstattung für ein Premium-Personal-Training-Business.",
  "pts.pkg.studiopro.i0": "Etablierte Personal Trainer",
  "pts.pkg.studiopro.i1": "Premium-Studios",
  "pts.pkg.studiopro.i2": "Höhere Kundenkapazität",
  "pts.pkg.studiopro.i3": "Kleingruppentraining",
  "pts.pkg.studiopro.i4": "Performance-Training",
  "pts.pkg.studiopro.concept": "Eine umfassendere Kombination aus Kraftgeräten, Functional-Training-, Freihantel- und Cardio-Ausstattung.",
  "pts.pkg.studiopro.cta": "Mein Studio Pro starten",
  "pts.pkg.idealFor": "Ideal für",
  "pts.pkg.conceptLabel": "Ausstattungskonzept",
  "pts.pkg.quote": "Fordern Sie Ihr Projektangebot an",
  "pts.pkg.note": "Keine Festpreise online — jedes Studio wird als Projekt kalkuliert, abgestimmt auf Ihren Raum, Ihre Methodik und Ihr Investitionsniveau.",
  "pts.eq.label": "Gemacht für echtes Training",
  "pts.eq.h2a": "Professionelle Qualität.",
  "pts.eq.h2b": "Gebaut für den täglichen professionellen Einsatz.",
  "pts.eq.copy": "Dieselben Gerätelinien, die kommerzielle Fitnessstudios beliefern — konstruierte Rahmen, patentierte Bewegungsführung und werkserprobte Langlebigkeit — intelligent skaliert für ein privates Trainingsstudio.",
  "pts.eq.strength": "Krafttraining",
  "pts.eq.functional": "Functional Training",
  "pts.eq.freeweights": "Freihanteln",
  "pts.eq.benches": "Bänke & Racks",
  "pts.eq.cable": "Kabelstationen",
  "pts.eq.cardio": "Cardio",
  "pts.eq.alt.strength": "Professionelle YANRE-Kraftgeräte für Personal Training Studios",
  "pts.eq.alt.functional": "YANRE Functional-Training-Ausstattung für professionelle Fitnessstudios",
  "pts.eq.alt.freeweights": "Professionelle YANRE-Freihantelausstattung für Personal Training Studios",
  "pts.eq.alt.benches": "Professionelle YANRE-Bänke und -Racks für Personal Training Studios",
  "pts.eq.alt.cable": "Professionelle YANRE-Kabelstationen für Personal Training Studios",
  "pts.eq.alt.cardio": "Professionelle YANRE-Cardiogeräte für Personal Training Studios",
  "pts.space.label": "Raumplanung",
  "pts.space.h2a": "Ihr Raum.",
  "pts.space.h2b": "Ihr Projekt.",
  "pts.space.copy": "Keine zwei Studios sind gleich. Geräteauswahl und Layout werden um Ihre Realität herum geplant — kein starres Katalogpaket.",
  "pts.space.f0": "Verfügbare Fläche",
  "pts.space.f1": "Trainingsmethodik",
  "pts.space.f2": "Anzahl gleichzeitiger Kunden",
  "pts.space.f3": "Investitionsniveau",
  "pts.space.f4": "Direktkauf ab Werk",
  "pts.space.f4d": "Professionelle YANRE-Fitnessgeräte ohne unnötige Händlerebenen.",
  "pts.space.f5": "Betriebsbereites Studio",
  "pts.space.f5d": "Professionelle Ausstattung, intelligentes Layout und ein komplettes Studiokonzept — bereit für Ihr Business.",
  "pts.space.cta": "Mein Studio-Projekt starten",
  "pts.direct.label": "Direkt vom Hersteller",
  "pts.direct.h2a": "Keine Zwischenhändler.",
  "pts.direct.h2b": "Keine Kompromisse.",
  "pts.direct.copy": "YANRE ist der Hersteller — entwickelt und produziert seit 1997 eigene professionelle Fitnessgeräte in den eigenen Werken in China, mit kommerzieller Betreuung aus Europa. Ihr Projekt, Ihr Gerätevertrag und Ihre Garantie liegen direkt beim Werk, das Ihre Maschinen baut.",
  "pts.direct.p0": "Professionelle Fitnessgeräte",
  "pts.direct.p1": "Direkte Herstellerbeziehung",
  "pts.direct.p2": "Garantie mit Werksrückhalt",
  "pts.direct.p3": "Internationaler Logistik-Support",
  "pts.direct.p4": "Projektberatung",
  "pts.direct.p5": "After-Sales-Support",
  "pts.process.label": "So funktioniert's",
  "pts.process.h2a": "Ein klarer Prozess.",
  "pts.process.h2b": "Von der Idee bis zum Eröffnungstag.",
  "pts.process.1.t": "Beratung",
  "pts.process.1.b": "Wir verstehen Sie, Ihren Raum, Ihr Konzept und Ihr Investitionsniveau.",
  "pts.process.2.t": "Projekt",
  "pts.process.2.b": "Gemeinsam definieren wir die Geräteauswahl und das Studio-Layout.",
  "pts.process.3.t": "Bestellung — 30 %",
  "pts.process.3.b": "Bestätigen Sie das Projekt und starten Sie die Produktion mit einer 30-%-Zahlung ans Werk.",
  "pts.process.4.t": "Produktion",
  "pts.process.4.b": "YANRE fertigt und bereitet Ihre Ausstattung vor.",
  "pts.process.5.t": "70 % vor Versand",
  "pts.process.5.b": "Der Restbetrag wird vor dem Versand gemäß offiziellem Vertrag beglichen.",
  "pts.process.6.t": "Versand",
  "pts.process.6.b": "Internationale Logistik, koordiniert für Ihr Projekt.",
  "pts.process.7.t": "After-Sales",
  "pts.process.7.b": "Werksseitiger Support nach der Installation.",
  "pts.monetize.label": "Monetarisieren Sie freie Studiozeiten",
  "pts.monetize.h2a": "Lassen Sie Ihr Studio arbeiten,",
  "pts.monetize.h2b": "auch wenn Sie nicht da sind.",
  "pts.monetize.copy": "Ihr Studio muss nicht nur dann Wert schaffen, wenn Sie Ihre eigenen Kunden trainieren. Freie Zeiten können zu einer zusätzlichen Einnahmequelle werden, indem andere Personal Trainer Zugang zu Ihrem professionellen Trainingsraum erhalten.",
  "pts.monetize.clients": "Ihre Kunden",
  "pts.monetize.clientsSub": "Ihre eigenen Trainingseinheiten",
  "pts.monetize.hours": "Freie Zeiten",
  "pts.monetize.hoursSub": "Andere Trainer nutzen Ihr Studio",
  "pts.monetize.revenue": "Eine Weitere Einnahmequelle",
  "pts.monetize.revenueSub": "Nutzen Sie Ihren Raum über den Tag besser aus",
  "pts.monetize.closeA": "Das Studio gehört Ihnen.",
  "pts.monetize.closeB": "Sie kontrollieren den Zeitplan.",
  "pts.form.label": "Starten Sie Ihr Studio-Projekt",
  "pts.form.h2a": "Erzählen Sie uns von",
  "pts.form.h2b": "Ihrem Studio.",
  "pts.form.sub": "Zwei Minuten. Ein Spezialist antwortet mit einem konkreten Ausstattungsvorschlag für Ihren Raum und Ihr Budget.",
  "pts.form.intro.sub1": "4 SCHNELLE SCHRITTE.",
  "pts.form.intro.sub2": "EINE KOMPLETTE LÖSUNG FÜR IHR STUDIO.",
  "pts.form.intro.support": "Erzählen Sie uns in nur 4 einfachen Schritten von Ihrem Studio. Unser Team versteht Ihre Anforderungen und hilft Ihnen, die passende Lösung zu bauen — mit direkter Werkslieferung von YANRE FITNESS China, professioneller Beratung und After-Sales-Support.",
  "pts.form.intro.minute": "FERTIG IN 1 MINUTE",
  "pts.form.progress": "Schritt",
  "pts.form.back": "Zurück",
  "pts.form.continue": "Weiter",
  "pts.form.submit": "Mein Studio-Projekt anfordern",
  "pts.form.sending": "Wird gesendet…",
  "pts.form.err.step": "Bitte füllen Sie die Pflichtfelder aus, um fortzufahren.",
  "pts.form.err.submit": "Beim Senden Ihres Projekts ist etwas schiefgelaufen. Bitte versuchen Sie es erneut.",
  "pts.success.title": "Ihr Studio-Projekt ist eingegangen.",
  "pts.success.body": "Ein YANRE-Spezialist prüft Ihre Angaben und kontaktiert Sie, um über Ihr Studio, Ihren Ausstattungsbedarf und die nächsten Schritte zu sprechen.",
  "pts.success.reference": "Referenz",
  "pts.success.cta": "YANRE FITNESS besuchen",
  "pts.q.areYou": "Was beschreibt Sie am besten?",
  "pts.q.planning": "Was planen Sie?",
  "pts.q.package": "Welches Studio-Paket interessiert Sie?",
  "pts.q.location": "Haben Sie bereits einen Standort?",
  "pts.q.size": "Ungefähre Studiofläche:",
  "pts.q.timeline": "Wann planen Sie die Eröffnung Ihres Studios?",
  "pts.q.investment": "Wie hoch ist Ihr geschätztes Investitionsbudget? (USD)",
  "pts.q.needs": "Was benötigen Sie?",
  "pts.q.needsHint": "Wählen Sie alles Zutreffende aus.",
  "pts.q.country": "Land",
  "pts.q.city": "Stadt",
  "pts.q.fullName": "Vollständiger Name",
  "pts.q.email": "E-Mail",
  "pts.q.phone": "Telefon / WhatsApp",
  "pts.q.company": "Firma / Studioname (optional)",
  "pts.q.selectCountry": "Land auswählen",
  "pts.step.1": "Studio",
  "pts.step.2": "Fläche",
  "pts.step.3": "Investition",
  "pts.step.4": "Kontakt",
  "pts.step.5": "Ausstattungsbedarf",
  "pts.step.6": "Kontakt",
  "pts.opt.role.personal-trainer": "Personal Trainer",
  "pts.opt.role.sc-coach": "Athletiktrainer",
  "pts.opt.role.studio-owner": "Studio-Inhaber",
  "pts.opt.role.investor-entrepreneur": "Investor / Unternehmer",
  "pts.opt.role.other": "Andere",
  "pts.opt.plan.first-studio": "Mein erstes Studio eröffnen",
  "pts.opt.plan.upgrade-studio": "Mein aktuelles Studio erweitern",
  "pts.opt.plan.another-location": "Einen weiteren Standort eröffnen",
  "pts.opt.pkg.starter": "STARTER",
  "pts.opt.pkg.studio-pro": "STUDIO PRO",
  "pts.opt.pkg.need-help": "Ich brauche Hilfe bei der Auswahl",
  "pts.opt.loc.confirmed": "Ja",
  "pts.opt.loc.looking": "Aktuell auf der Suche",
  "pts.opt.loc.not-yet": "Noch nicht",
  "pts.opt.size.under-50": "Weniger als 50 m²",
  "pts.opt.size.50-100": "50–100 m²",
  "pts.opt.size.100-200": "100–200 m²",
  "pts.opt.size.over-200": "Über 200 m²",
  "pts.opt.size.undefined": "Noch nicht definiert",
  "pts.opt.time.1-2": "1–2 Monate",
  "pts.opt.time.2-4": "2–4 Monate",
  "pts.opt.time.4-6": "4–6 Monate",
  "pts.opt.time.6-plus": "Mehr als 6 Monate",
  "pts.opt.inv.under-10k": "Weniger als 10.000",
  "pts.opt.inv.10-20k": "10.000–20.000",
  "pts.opt.inv.20-40k": "20.000–40.000",
  "pts.opt.inv.40-80k": "40.000–80.000",
  "pts.opt.inv.80k-plus": "Über 80.000 USD",
  "pts.opt.need.complete-studio-equipment": "Komplette Studio-Ausstattung",
  "pts.opt.need.strength": "Kraftgeräte",
  "pts.opt.need.functional": "Functional Training",
  "pts.opt.need.cardio": "Cardiogeräte",
  "pts.opt.need.full-project-help": "Ich brauche Hilfe beim kompletten Projekt",
  "pts.opt.role.gym-owner-operator": "Gym-Inhaber / -Betreiber",
  "pts.opt.inv.under-20k": "Weniger als 20.000 USD",
  "pts.opt.inv.20-30k": "20.000–30.000 USD",
  "pts.opt.inv.30-50k": "30.000–50.000 USD",
  "pts.opt.inv.50-80k": "50.000–80.000 USD",
  "err.phoneInvalid": "Bitte geben Sie eine gültige Telefonnummer für das ausgewählte Land ein.",
  "footer.tagline": "YANRE FITNESS EUROPE — die europäische Heimat eines etablierten internationalen Herstellers von Kraftgeräten in Studioqualität und kompletten Fitnesslösungen.",
};
